// extracted by mini-css-extract-plugin
export default {"Root":"JackpotGameModal_Root__sC2o1","BannerBtn":"JackpotGameModal_BannerBtn__WH9b8","Banner":"JackpotGameModal_Banner__lyAbK"};